import { GridRenderCellParams } from '@mui/x-data-grid-premium';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import React from 'react';
import { TABLE_MIN_COLUMN_WIDTH } from '../../../constants';
import { getTranslatedValue } from '../../ApprovalPageTable/utils';

export const returnTableColumns = (t) => [
  {
    field: 'id',
    headerName: t('common.id'),
    width: 90,
    minWidth: TABLE_MIN_COLUMN_WIDTH,
    hide: true,
  },
  {
    field: 'name',
    headerName: t('user.properties.userName'),
    width: 400,
    minWidth: TABLE_MIN_COLUMN_WIDTH,
    renderCell: (params: GridRenderCellParams) => (
      <Tooltip title={params?.row?.name}>
        <Typography noWrap>{params?.row?.name}</Typography>
      </Tooltip>
    ),
  },
  {
    field: 'email',
    headerName: t('common.email'),
    width: 350,
    minWidth: TABLE_MIN_COLUMN_WIDTH,
    renderCell: (params: GridRenderCellParams) => (
      <Tooltip title={params?.row?.email}>
        <Typography noWrap>{params?.row?.email}</Typography>
      </Tooltip>
    ),
  },
  {
    field: 'role',
    headerName: t('common.role'),
    width: 200,
    minWidth: TABLE_MIN_COLUMN_WIDTH,
    valueGetter: (value, row) =>
      getTranslatedValue(row?.expansionUserRole, 'roles', t),
    renderCell: (params: GridRenderCellParams) => params?.value,
  },
  {
    field: 'countries',
    headerName: t('common.country'),
    width: 250,
    minWidth: TABLE_MIN_COLUMN_WIDTH,
    valueGetter: (value, row) =>
      row?.countries.map((country, idx) => {
        if (idx === row?.countries.length - 1) return country;
        else return `${country}, `;
      }),
    renderCell: (params: GridRenderCellParams) => params?.value,
  },
];
